import ErrorBoundary from "components/error-boundary";
import ScRequestMaterialLog from "./sc-request-material-log";

/**
 * Internal, read-only "SC request" material log page.
 *
 * Reachable by URL only at `/project/:projectId/materials/sc-request` (no nav
 * entry). Relies on `ProjectContext` being provided by the authenticated app
 * shell that hosts the material routes, so no extra provider wiring is needed.
 */
function InternalScRequestPage() {
  return (
    <ErrorBoundary>
      <div
        className="flex flex-col h-full w-full"
        data-testid="internal-sc-request-page"
      >
        <ScRequestMaterialLog />
      </div>
    </ErrorBoundary>
  );
}

export default InternalScRequestPage;
